import { Component, Prop } from 'vue-property-decorator';
import { BaseComponent } from '@/components/base-component';
import { ImageResourceDTO } from '../../model/ImageResourceDTO';
import { getProperSize } from '../../helpers/images';

import { find } from 'lodash-es';

@Component
export class GalleryItem extends BaseComponent {
	@Prop() galleryId: string;
	@Prop() resource: ImageResourceDTO[];
	@Prop() sizes: string;
	@Prop() description: boolean;

	get fullSizeImage() {
		return getProperSize(this.resource, 1200);
	}

	get src() {
		return this.formatImageUrl(getProperSize(this.resource, 1000).path);
	}

	get srcset() {
		return this.resource.map(r => `${this.formatImageUrl(r.path)} ${r.width}w`).join(", ");
	}

	get alt() {
		let alt = find(this.resource, function (o) { return o.description != null });
		return alt ? alt.description : "";
	}
}

export default GalleryItem;
